import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import realisationsData from '../data/realisations';

export function useRealisations() {
    const { t } = useTranslation('realisations');

    return useMemo(
        () =>
            realisationsData.map((realisation) => ({
                ...realisation,
                title: t(`${realisation.id}.title`),
                client: t(`${realisation.id}.client`),
                description: t(`${realisation.id}.description`),
                prix: t(`${realisation.id}.prix`),
            })),
        [t]
    );
}

export function useRealisation(id) {
    const realisations = useRealisations();
    return realisations.find((r) => r.id === Number(id));
}
